/*
 * Adzuki.Editor
 * TinyMCE WYSIWYG text editor shim
 * https://www.tinymce.com/docs/
 */

(function Editors($, Adzuki, tinymce)
{
	"use strict";

	// #modalWindow specifically, NOT $('.modal'): the Trip Summary builder page
	// also renders #ts-component-modal, and a bare .modal selector shows both —
	// trapping the user behind a static-backdrop modal they cannot dismiss.
	// (image_size was dropped here on purpose: media-hub removed the editor's
	// image-size feature, so its only remaining reference was this declaration.)
	var $modal     = $('#modalWindow'),
	    script_url_whitelist = [
	        'form.jotform.com',
	        'assets.freshdesk.com',
	        'reviews.sproutloud.com',
	        'platform.reviewmgr.com',
	        'static.reviewmgr.com',
	        'www.tiktok.com',
			'widgets.meetsoci.com',
	    ];

	var editor = function Editor(el, options)
	{
		var self = this,
		    menubar_sets = {
		        // when adding menubars, please keep them in alphabetical order
		        // to make them easier to manage
		        account     : 'edit format table',
		        advanced    : 'edit insert view format table tools',
		        email       : 'edit view format',
		        guide       : 'edit view format',
		        minimal     : false,
		        moderate    : 'edit view format',
		        partner_hub : false,
		        simple      : 'edit view format',
		        simple_email: 'edit view format',
		        text_formats: false,
		        web         : 'edit insert view format table tools',
		    },
		    plugin_sets = {
		        // when adding plugins, please keep them in alphabetical order
		        // to make them easier to manage
		        account     : 'code lists table',
		        advanced    : 'code image link lists paste preview table media',
		        email       : 'code image link lists preview table',
		        guide       : 'code image link lists preview table',
		        minimal     : 'lists paste',
		        moderate    : 'code image link lists paste preview table media',
		        partner_hub : 'lists paste',
		        simple      : 'code image link lists paste preview table',
		        simple_email: 'code image link lists paste preview table',
		        text_formats: 'link lists',
		        web         : 'anchor code image imagetools link lists paste preview table media bootstrap3grid',
		    },
		    toolbar_sets = {
		        // custom buttons we add below in setup()
		        // 	cp_images, cp_forms, cp_form_remove, gpt_prompt

		        // when adding toolbars, please keep them in alphabetical order
		        // to make them easier to manage
		        account: [
		            'bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | code | table | undo redo',
		        ],
		        advanced: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | link unlink anchor image code | table charmap emoticons | cp_images cp_videos | cut copy paste pastetext snippets | searchreplace | undo redo | hr visualchars | fullscreen',
		        ],
		        email: [
		            'fontselect fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image | table | cp_images cp_videos | snippets | undo redo',
		        ],
		        guide: [
		            'fontselect fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image | table | cp_images | snippets | undo redo',
		        ],
		        minimal: [
		            'bold italic underline | bullist numlist outdent indent',
		        ],
		        moderate: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image code | table | cp_images cp_videos | snippets | undo redo',
		        ],
		        partner_hub: [
		            'bold italic underline | bullist numlist outdent indent',
		        ],
		        simple: [
		            'fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image code | table | cp_images cp_videos | pastetext snippets | undo redo',
		        ],
		        simple_email: [
		            'fontsizeselect | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink image code | table | cp_images | pastetext snippets | undo redo',
		        ],
		        text_formats: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link unlink | undo redo',
		        ],
		        web: [
		            'fontselect fontsizeselect | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent blockquote | link unlink anchor image media code | bootstrap3grid table charmap emoticons | cp_images cp_forms cp_form_remove cp_videos | cut copy paste pastetext snippets | searchreplace | undo redo | hr visualchars | fullscreen',
		        ],
		    },
		    statusbar_sets = {
		        // when adding status bar, please keep them in alphabetical order
		        // to make them easier to manage
				account     : true,
				advanced    : true,
				email       : true,
				guide       : true,
				minimal     : false,
				moderate    : true,
				partner_hub : false,
				simple      : true,
				simple_email: true,
				text_formats: true,
				web         : true,
		    },

		    defaults = {
		        // skin              : 'oxide-dark',
		        menubar           : menubar_sets.simple,
		        plugins           : plugin_sets.simple,
		        toolbar           : toolbar_sets.simple,
		        statusbar         : statusbar_sets.simple,
		        contextmenu       : false,
		        removed_menuitems : 'newdocument',
		        image_advtab      : true,
		        browser_spellcheck: true,
		        relative_urls     : false,
		        remove_script_host: false,
		        setup             : function _setup(editor)
		        {
		            var gpt_text;
		            var gpt_tooltip;

		            editor.on('change', function _change() {
		                _updateHiddenInput(editor);
		            });

		            editor.ui.registry.addButton('cp_images', {
		                // this is the actual, real way to have custom images
		                // in a custom button in their new ui framework, without
		                // having to make an svg and using their new icon registry api
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-maxx-media.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : ' Maxx Media File Manager',
		                onAction: function clickCustomButton(event) {
		                    showImagePicker(editor);
		                }
		            });

		            editor.ui.registry.addButton('cp_forms', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-forms.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Add form',
		                onAction: function clickCustomButton(event) {
		                    showFormSelector(editor);
		                }
		            });

		            editor.ui.registry.addButton('cp_form_remove', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-forms-remove.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Remove form',
		                onAction: function clickCustomButton(event) {
		                    removeForm(editor);
		                }
		            });

					editor.ui.registry.addButton('cp_form_remove', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-forms-remove.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Remove form',
		                onAction: function clickCustomButton(event) {
		                    removeForm(editor);
		                }
		            });

		            // an unlabeled monogram at the end of a 30-button toolbar reads as just
		            // another format button. Apps that opt into gpt_prominent get the icon
		            // plus a "Write with AI" label, promoted to the front of the toolbar.
		            gpt_text = '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-maxx-gpt.png" style="height: 24px;width: 24px;padding: 3px 0px 0px 0px;"/ >';
		            gpt_tooltip = 'Maxx Intelligence Content Generator';

		            if (Adzuki.gpt_prominent === 1) {
		                gpt_text = '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-maxx-gpt.png" style="height: 18px;width: 18px;margin: 0px 6px 0px 0px;vertical-align: -4px;"/ ><span style="font-weight: 600;">Write with AI</span>';

		                // the label already says what the button does, so the tooltip names the
		                // tool behind it rather than repeating the action
		                gpt_tooltip = 'Maxx Intelligence';
		            }

		            editor.ui.registry.addButton('gpt_prompt', {
		                text    : gpt_text,
		                tooltip : gpt_tooltip,
		                onAction: function clickCustomButton(event) {
		                    showGptPrompt(editor);
		                }
		            });

					editor.ui.registry.addButton('snippets', {
		                text    : '<image src="'+Adzuki.base_uri+'/adzuki/images/tinymce-snippets.png " style="height: 24px;width: 20px;padding: 3px 0px 0px 0px;"/ >',
		                tooltip : 'Snippets',
		                onAction: function clickCustomButton(event) {
		                    showSnippets(editor);
		                }
		            });


		            // save internal reference to the tinymce editor itself
		            self._editor = editor;
		        },
		    },
		    _updateHiddenInput = Adzuki.Debounce(function __updateHiddenInput(editor) {
		        // this syncs the hidden input's value with tinymce's contents
		        editor.save();

		        // this syncs EVERY tinymce editor on the page
		        // tinymce.triggerSave();
		    }, 250),
		    opts = $.extend({}, defaults, options),
		    editorElement;

		try
		{
			if ($.isEmptyObject(tinymce)) {
				throw new Error('TinyMCE is not loaded.');
			}

			if ((this instanceof Editor) === false) {
				return new Editor(el, options);
			}

			// a page in dark mode can ask for TinyMCE's dark toolbar and frame by naming a
			// skin on <body> (Trip Summary does, MEDIA-321). The editing area keeps the
			// light content css, so what the agent writes looks as the client will see it.
			if (opts.skin === undefined && document.body.getAttribute('data-cpui-editor-skin')) {
				opts.skin = document.body.getAttribute('data-cpui-editor-skin');
			}

			if (typeof el === 'string') {
				editorElement = el;
				this.$editor  = $(editorElement);
			}
			else if (typeof el === 'object' && (el instanceof jQuery)) {
				throw new Error("jQuery objects are not supported.");
			}

			if (!this.$editor.length) {
				throw new Error('cannot find ' + editorElement);
			}

			opts.selector = editorElement;

			// editor type set via form data attribute
			if (this.$editor.data('editor-type') !== undefined) {
				opts.menubar   = menubar_sets[this.$editor.data('editor-type')];
				opts.plugins   = plugin_sets[this.$editor.data('editor-type')];
				opts.toolbar   = toolbar_sets[this.$editor.data('editor-type')];
				opts.statusbar = statusbar_sets[this.$editor.data('editor-type')];
			}

			// editor type being set via JS call to Adzuki.Editor
			if (opts.editor_type !== undefined) {
				opts.menubar   = menubar_sets[opts.editor_type];
				opts.plugins   = plugin_sets[opts.editor_type];
				opts.toolbar   = toolbar_sets[opts.editor_type];
				opts.statusbar = statusbar_sets[opts.editor_type];
			}

			if (Adzuki.gpt_enabled === 1) {
				// appended last, it sits past undo/redo at the far right — the lowest
				// attention spot on the strip. Prominent apps lead with it instead.
				if (Adzuki.gpt_prominent === 1) {
					opts.toolbar[0] = 'gpt_prompt | ' + opts.toolbar[0];
				} else {
					opts.toolbar[0] += ' | gpt_prompt';
				}
			}

			// imagetools needs a proxy to work
			// https://www.tiny.cloud/docs/plugins/opensource/imagetools/
			if (opts.plugins.indexOf('imagetools') > -1) {
				opts.imagetools_proxy   = Adzuki.base_uri + '/Images/mceproxy/';
				opts.imagetools_toolbar = 'rotateleft rotateright | flipv fliph | editimage imageoptions';
			}

			// special stylings for agent websites
			if (opts.content_css !== undefined) {
				opts.content_css = [
					'//fonts.googleapis.com/css?family=Open+Sans',
					Adzuki.base_uri+'/adzuki/css/vendor/vendor.min.css',
					Adzuki.base_uri+'/adzuki/css/'+opts.content_css,
				];

				opts.font_formats = 'Arial=arial,helvetica,sans-serif;'
				+'Arial Black=arial black,sans-serif;'
				+'Book Antiqua=book antiqua,palatino,serif;'
				+'Comic Sans MS=comic sans ms,sans-serif;'
				+'Open Sans=Open Sans, sans-serif;'
				+'Times New Roman=times new roman,times,serif;';

				opts.fontsize_formats = '8px 10px 12px 14px 18px 24px 36px';
			}

			// if we have to add insecure shit due to agents requesting it
			// at least we can /try/ to make it decent with a whitelist
			opts.extended_valid_elements = 'video[controls|playsinline|width|height|autoplay|muted],source[src|type],script[type=text/javascript|src]';
			opts.urlconverter_callback   = function validateUrl(url, node, on_save, name)
			{
				var script,
				    mce_settings = self._editor.settings;

				// parse the script url, check if hostname is in whitelist
				if (node === 'script')
				{
					script = document.createElement('a');
					script.href = url;

					if (script_url_whitelist.indexOf(script.hostname) >= 0) {
						return url;
					}

					return '';
				}

				// port of original tinymce.convertURL() functionality
				// without recursively calling the urlconverter_callback function
				if (
					!mce_settings.convert_urls ||
					node === "a" ||
					(node !== undefined && node.nodeName && node.nodeName.toLowerCase() === 'a') ||
					url.indexOf('file:') === 0 ||
					url.length === 0
				) {
					// console.log('url', url);
					return url;
				}
				else if (
					!mce_settings.convert_urls ||
					node === "img" ||
					(node !== undefined && node.nodeName && node.nodeName.toLowerCase() === 'img') ||
					url.indexOf('file:') === 0 ||
					url.length === 0
				) {
					// console.log('url', url);
					return url;
				}
				else if (mce_settings.relative_urls) {
					// console.log('documentBaseURI.toRelative', self._editor.documentBaseURI.toRelative(url));
					return self._editor.documentBaseURI.toRelative(url);
				}

				// console.log('documentBaseURI.toAbsolute', self._editor.documentBaseURI.toAbsolute(url, mce_settings.remove_script_host));
				return self._editor.documentBaseURI.toAbsolute(url, mce_settings.remove_script_host);
			};

			// set base path for icons, plugins, skins, and themes
			tinymce.baseURL = Adzuki.base_uri + '/adzuki/js/vendor/tinymce';

			// remove any tinymce instances that are already initialized for this el
			tinymce.remove(editorElement);

			// tinymce 5 doesn't allow us to extend the default colormap
			// list of available colors, so set all of the stock ones here
			// and add the cruise planners one as well.
			// the weird structure is legit, not a typo. idunno, man.
			opts.color_map = [
				'#BFEDD2', 'Light Green',
				'#FBEEB8', 'Light Yellow',
				'#F8CAC6', 'Light Red',
				'#ECCAFA', 'Light Purple',
				'#C2E0F4', 'Light Blue',
				'#2DC26B', 'Green',
				'#F1C40F', 'Yellow',
				'#E03E2D', 'Red',
				'#B96AD9', 'Purple',
				'#3598DB', 'Blue',
				'#169179', 'Dark Turquoise',
				'#E67E23', 'Orange',
				'#BA372A', 'Dark Red',
				'#843FA1', 'Dark Purple',
				'#236FA1', 'Dark Blue',
				'#ECF0F1', 'Light Gray',
				'#CED4D9', 'Medium Gray',
				'#95A5A6', 'Gray',
				'#7E8C8D', 'Dark Gray',
				'#34495E', 'Navy Blue',
				'#000000', 'Black',
				'#FFFFFF', 'White',
				"#3AAF49", "Cruise Planners Green",
			];

			// tinymce 5 changed how height works, this compensates for the change
			// this only works if a height is specified
			if (opts.height) {
				opts.height += 170;
			}
			else {
				// tinymce5's default height seems a bit smaller than before
				// so this'll make them look about the same
				opts.height = 300;
			}

			// remove "powered by"
			opts.branding = false;

			// support image uploading
			// function(blobInfo, successHandler, failureHandler)
			if (typeof opts.images_upload_handler !== 'function'
				&& this.$editor.data('image-upload-url') !== undefined)
			{
				opts.images_upload_url = Adzuki.get_url(this.$editor.data('image-upload-url'));
			}

			opts.media_live_embeds = true;

			// init
			tinymce.init(opts).then(function ready(editors) {
				self.$editor.trigger('editor.ready', editors[0]);

				editors[0].on('dblclick', function _captureClick(e) {
					if (e.target.className === 'maxx-media-thumb img-responsive') {
						showVideoModal($(e.target).data('video-url'));
					}
				});
			});

			this.$editor.addClass('has-html');
		}
		catch (err)
		{
			console.log('[Adzuki.Editor]', err);
		}

		// cp images toolbar item functions
		// cp images toolbar item functions
		function showImagePicker(editor)
		{
			let selectedMediaIds = null;
			let selectedMedia   = [];
			let iframeSrc       = Adzuki.mediahub_url + Adzuki.base_uri + '/Media/cpMediaHub/section:wysiwyg';

			// Optional needs_approval override for this Media Hub open.
			// When present, cpMediaHub overwrites the loaded section's needs_approval
			// so all existing sectionInfo.needs_approval checks work unchanged.
			// Also accept needsapproval (data-editor-options-needs-approval via form.js).
			let needsApprovalOpt = null;

			if (typeof opts.needs_approval === 'boolean') {
				needsApprovalOpt = opts.needs_approval;
			} else if (typeof opts.needsapproval === 'boolean') {
				needsApprovalOpt = opts.needsapproval;
			}

			if (needsApprovalOpt !== null) {
				iframeSrc += '/needs_approval:' + (needsApprovalOpt ? '1' : '0');
			}

			// MEDIA-334: the picker's own header (logo, "Maxx Media File Manager", the
			// soft close), from component/_mh_host_modal.scss, while this is open
			$modal.addClass('wide mh-host-modal');
			$modal.find('.modal-title').text('Maxx Media File Manager');
			$modal.find('.modal-body').html(
				'<iframe '
				+ 'src="'
				+ iframeSrc + '" '
				+ 'width="100%" '
				+ 'height="100%" '
				+ 'style="height:90vh; border:none;" '
				+ 'allowfullscreen>'
				+ '</iframe>'
			);

			// Remove any existing message handlers before adding a new one
			if (window.currentMediaHandler) {
				window.removeEventListener('message', window.currentMediaHandler);
			}

			window.currentMediaHandler = function mediaHubResponse(e) {
				function insertMediaContent(media, saved_file_name) {
					// prefer the name the server actually wrote to the content_editor
					// directory, since it can be renamed to avoid a collision
					let file_name = saved_file_name || media.original_file_name;
					let local_file_url;
					let thumbnail_url;

					function resolveInsertedUrl(path) {
						if (!path) {
							return '';
						}

						if ((/^https?:\/\//i).test(path)) {
							return path;
						}

						return Adzuki.current_website + '/' + String(path).replace(/^\//, '');
					}

					if ((/^https?:\/\//i).test(file_name)) {
						local_file_url = file_name;
					} else {
						local_file_url = resolveInsertedUrl('images/maxx_media/content_editor/' + file_name);
					}

					thumbnail_url = resolveInsertedUrl(media.thumbnail_image);

					if (media.type === 'image') {
						let defaultWidth = Math.min(media.width || 500, 500);
						editor.insertContent('<img class="img-responsive" src="'+ local_file_url + '" width="' + defaultWidth + '" style="height: auto;">');
					} else if (media.type === 'video') {
						editor.insertContent('<a href="'+ local_file_url + '" target="_blank"><img class="maxx-media-thumb img-responsive" src="'+ thumbnail_url + '" style="height: auto;" data-video-url="' + local_file_url + '" /></a>');
					} else {
						editor.insertContent('<a href="'+ local_file_url + '" target="_blank">' + media.title + '</a>');
					}
				}

				try {
					console.log('Media Hub Response:', e);
					if (!e || !e.data || e.data.type !== 'MEDIA_SELECTED') {
						return;
					}

					const mediaId = e.data.payload.media_id;
					selectedMediaIds = [mediaId];

					const mediaPromises = selectedMediaIds.map(function getMedia(id) {
						return Adzuki.Ajax.get('/Media/getMediaItem/' + id);
					});

					// Wait for all promises to resolve
					Promise.all(mediaPromises)
						.then(function allMediaLoaded(mediaItems) {
							// a php notice or uncaught exception makes the endpoint
							// respond with html, which arrives here as a string
							selectedMedia = mediaItems.filter(function isMediaItem(media) {
								if (media !== null && typeof media === 'object' && media.id !== undefined) {
									return true;
								}

								console.error('Unexpected /Media/getMediaItem response:', media);
								return false;
							});

							if (selectedMedia.length !== mediaItems.length) {
								Adzuki.StatusMessage('Error', 'We could not load the media you selected. Please try again.');
							}

							if (selectedMedia.length > 0) {
								selectedMedia.forEach(function insertMedia(media) {
									// When this editor requires approval, only approved media may be inserted.
									// When needs_approval is false/omitted, insert regardless of status
									// (restricted/pending stay usable in the content editor).
									if (needsApprovalOpt === true && media.status !== 'approved') {
										Adzuki.StatusMessage('Error', 'The media you selected has been submitted for Home Office approval and being reviewed for AI and/or copyright criteria. Please select or upload another image. You may reach out to <a href="mailto:marketing@cruiseplanners.com">marketing@cruiseplanners.com</a> if you have any questions regarding the approval process.');
										return;
									}

									const saveFilePayload = {
										media_id : media.id,
										save_path: 'images/maxx_media/content_editor/',
									};

									const normalizedMediaPath = String(media.path || '').replace(/\/$/, '');
									const normalizedSavePath  = saveFilePayload.save_path.replace(/\/$/, '');

									if (normalizedMediaPath === normalizedSavePath) {
										insertMediaContent(media);
										return;
									}

									Adzuki.Ajax.post('/Media/saveFileLocal', saveFilePayload)
										.then(function fileLocalSaved(response) {
											console.log('File saved locally:', response);

											if (!response || response.status !== 'success') {
												console.error('Error saving file locally:', response);
												Adzuki.StatusMessage('Error', 'Failed to save file locally. Please try again.');
												return;
											}

											insertMediaContent(media, response.saved_file && response.saved_file.name);
										})
										.catch(function saveError(error) {
											console.error('Error saving file locally:', error);
											Adzuki.StatusMessage('Error', 'Failed to save file locally. Please try again.');
										});
								});
							}

							// Clean up: remove the event listener after processing
							window.removeEventListener('message', window.currentMediaHandler);
							window.currentMediaHandler = null;
						}).catch(function error(err) {
							   console.error('Error loading media items:', err);
							   Adzuki.StatusMessage('Error', 'We could not load the media you selected. Please try again.');
							   // Clean up on error as well
							   window.removeEventListener('message', window.currentMediaHandler);
							   window.currentMediaHandler = null;
						   });

					$modal.modal('hide');
				} catch (err) {
					console.error(err);
					// Clean up on error
					window.removeEventListener('message', window.currentMediaHandler);
					window.currentMediaHandler = null;
				}
			};

			window.addEventListener('message', window.currentMediaHandler, false);

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide mh-host-modal').off('hidden.bs.modal');
				// Also clean up the message handler when modal is closed without selection
				if (window.currentMediaHandler) {
					window.removeEventListener('message', window.currentMediaHandler);
					window.currentMediaHandler = null;
				}
			}).modal('show');

		}

		// lead forms toolbar item functions
		function showFormSelector(editor)
		{
			$modal.find('.modal-title').text('Forms');
			$modal.find('.modal-body').text('Loading forms...');

			Adzuki.Ajax.get('/ClientLeadForms/forms')
			.then(function _showClientLeadForms(html) {
				$modal.find('.modal-body').html(html);
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');

			$modal.on('click', '.lead-form', function selectForm() {
				var form_id       = $(this).data('id'),
					form_name     = $(this).data('name'),
					existing_page = editor.getContent({format: 'raw'});

				if (existing_page.indexOf('lead-form-container') > 0) {
					Adzuki.StatusMessage('Error', 'You can only have one CP Maxx form per page.');
				} else {
					editor.insertContent('<div class="lead-form-container" id="form-id-'+ form_id + '"><table cellpadding="10" cellspacing="0" style="padding: 10px; background-color: #FFFFF; text-align:center; font-size: 16px; border: 2px solid #666; color: #00000"><tr><td style="padding: 10px;"><img src="' + Adzuki.base_uri + '/images/maxx.png"></td><td style="padding: 10px;"><b>CP MAXX FORM</b><br> ' + form_name + '</td></tr></table></div><p></p>');
				}

				$modal.modal('hide');
				$modal.off('click', '.lead-form');
			});
		}

		function removeForm(editor)
		{
			var old_content = editor.getContent({format: 'raw'}),
				new_content = '',
				pattern     = /<div\s+id="form-id-[^"]*" class="lead-form-container">[\S\s]*?<\/div>/gi;

			if (old_content.match(pattern)) {
				new_content = old_content.replace(pattern, '');
				editor.setContent(new_content);
				editor.insertContent('');
			}
		}

		// snippets toolbar item functions
		function showSnippets(editor)
		{
			$modal.find('.modal-title').text('My Snippets');
			$modal.find('.modal-body').text('Loading Snippets...');
			$modal.find('.modal-body').html('');

			Adzuki.Ajax.get('/Snippets/snippetsPrompt')
			.then(function _showSnippets(html) {
				$modal.find('.modal-body').html(html);
				Adzuki.Form.initAjaxForm('SnippetPrompt');
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');

			// remove previous event listeners
			$modal.off('click', '.insert-snippet');

			$modal.on('click', '.insert-snippet', function _insertContent(e) {
				var content = '';

				e.preventDefault();

				content = $(this).data('snippet');

				if (content.length === 0) {
					Adzuki.StatusMessage('Error', 'There must be a snippet selected in order to proceed.');
					return false;
				}

				editor.insertContent(content + ' ');

				$modal.modal('hide');
			});
		}

		// maxx intelligence toolbar item functions — uses the same redesigned
		// .mi-panel that the Quick Actions Tools tab uses. An "Insert Content"
		// per-message action is exposed via the onInsertContent callback so
		// agents can pick which assistant reply to drop into the editor.
		function showGptPrompt(editor)
		{
			var miController = null,
				panel = null;

			$modal.find('.modal-title').text('Maxx Intelligence');
			$modal.find('.modal-body').html('Loading Maxx Intelligence...');

			// Remove any listeners from the legacy flow, just in case.
			$modal.off('click', '.insert-from-history');
			$modal.off('click', '.gpt-insert-content');

			Adzuki.Ajax.get('/main/maxxIntelligence').then(function _showGptPrompt(html) {
				// Wrap the panel in a sized flex column so .mi-panel's
				// flex:1/min-height:0 layout has real space to fill inside
				// the Bootstrap modal body.
				$modal.find('.modal-body').html(
					'<div class="mi-editor-wrap">' + html + '</div>'
				);

				panel = $modal.find('#mi-panel').get(0);

				if (!panel || !Adzuki.MaxxIntelligence) {
					return;
				}

				miController = Adzuki.MaxxIntelligence.init({
					root           : panel,
					onInsertContent: function handleInsertContent(message) {
						var content = (message && message.content) ? message.content : '';
						if (!content) {
							Adzuki.StatusMessage('Error', 'There must be a response provided in order to proceed.');
							return;
						}

						// Prefer rendered markdown (bold/links/etc.) so Insert Content
						// matches what the agent saw in the Maxx Intelligence panel.
						if (
							Adzuki.MaxxIntelligence
							&& typeof Adzuki.MaxxIntelligence.formatMarkdown === 'function'
						) {
							content = Adzuki.MaxxIntelligence.formatMarkdown(content);
							content = content.replace(/\r\n|\r|\n/g, '<br />');
						} else {
							content = content.replace(/\r\n/g, '<br />');
							content = content.replace(/\n/g, '<br />');
						}

						editor.insertContent(content);

						$modal.modal('hide');
					}
				});
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				if (miController && typeof miController.destroy === 'function') {
					miController.destroy();
					miController = null;
				}
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		}

		/* function showVideoLibrary(editor)
		{
			var content = '';

			$modal.find('.modal-title').text('Video Library');
			$modal.find('.modal-body').text('Loading Video Library...');

			$modal.off('click', '.insert-video');

			Adzuki.Ajax.get('/Videos/library')
			.then(function _showVideoLibrary(html) {
				$modal.find('.modal-body').html(html);
				Adzuki.Form.initAjaxForm('VideoFilter');
			});

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');


			$modal.on('click', '.insert-video', function insertVideoContent(e) {
				var video_url   = $(this).data('video-url'),
					thumbnail   = $(this).data('thumbnail'),
					internal_id = Math.floor(Date.now() / 1000),
					video_id    = $(this).data('id'),
					data_key    = $(this).data('key'),
					video_size  = $('.insert-video-size[data-key="' + data_key + '"]').val(),
					website     = $(this).data('website');

				e.preventDefault();

				content = '<img src="' + Adzuki.base_uri + '/' + thumbnail + '" class="video-library-placeholder img-responsive" style="max-width: ' + video_size + '" data-video-url="' + video_url + '" data-video-thumbnail="' + Adzuki.base_uri + '/' + thumbnail + '" data-internal-id="' + internal_id + '" data-video-website="' + website + '" data-video-id="' + video_id + '" />';
				content += '<br>';

				editor.insertContent(content);
				$modal.modal('hide');
			});
		} */

		function showVideoModal(video_src)
		{
			// Create video data object
			const videoHtml = '<video width="100%" height="500" controls>'
				+ '<source src="' + video_src + '" type="video/mp4">'
				+ 'Your browser does not support the video tag.'
				+ '</video>';

			$modal.addClass('wide');
			$modal.find('.modal-title').text('Video Player');
			$modal.find('.modal-body').html(videoHtml);

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.removeClass('wide').off('hidden.bs.modal');
			}).modal('show');
		}
	};

	Adzuki.Editor = editor;
}(jQuery, window.Adzuki || {}, window.tinymce || {}));
